/**
 * Thin wrapper around a full-page browser navigation. Exists purely so
 * auth-redirect call sites (utils/apiClient.ts, components/SignIn) can be
 * unit tested — jsdom's `window.location` (and `location.assign`) are
 * non-configurable/non-writable in this environment, so tests can't mock
 * them directly; they can mock this module instead.
 */
export function navigateTo(url: string): void {
  if (typeof window !== 'undefined') {
    window.location.assign(url);
  }
}
